import eventBus from '@refapp/eventbus-js';

// Helper functions
const shouldPreventDefault = (eventName, modifiers) => {
  return eventName === 'click' && modifiers.prevent;
};

const getEventPayload = (value, event, modifiers) => {
  if (value.eventName) {
    return modifiers.withevent ? { event, payload: value.payload } : value.payload;
  }
  return modifiers.withevent ? event : undefined;
};

const getEventNameToEmit = (value) => {
  return value.eventName || value;
};

const emitBusEvent = (value, event, modifiers) => {
  const eventName = getEventNameToEmit(value);
  const payload = getEventPayload(value, event, modifiers);

  if (payload === undefined) {
    eventBus.emit(eventName);
  } else {
    eventBus.emit(eventName, payload);
  }
};

const createEventListener = (eventName, value, modifiers) => {
  return (event) => {
    if (shouldPreventDefault(eventName, modifiers)) {
      event.preventDefault();
    }
    emitBusEvent(value, event, modifiers);
  };
};

const attachEventListeners = (el, value, modifiers) => {
  Object.keys(modifiers).forEach((eventName) => {
    if (eventName !== 'prevent') {
      const listener = createEventListener(eventName, value, modifiers);
      el.addEventListener(eventName, listener);
    }
  });
};

export const bus = {
  name: 'bus',
  beforeMount: (el, { modifiers, value }) => {
    if (!modifiers || 'object' !== typeof modifiers) return;
    attachEventListeners(el, value, modifiers);
  },
};
